import { EditUserReplayComponent } from './edit-user-replay/edit-user-replay.component';
import { UserReplayListingComponent } from './user-replay-listing/user-replay-listing.component';
import { EditContentComponent } from './edit-content/edit-content.component';
import { EditGroupNameComponent } from './edit-group-name/edit-group-name.component';
import { ContentGroupListingComponent } from './content-group-listing/content-group-listing.component';
import { ContentListingComponent } from './content-listing/content-listing.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ContentInfoComponent } from './content-info/content-info.component';
import { ContentPreviewComponent } from './content-preview/content-preview.component';
import { QuickResponseListComponent } from './quick-response-list/quick-response-list.component';
import { EditQuickResponseComponent } from './edit-quick-response/edit-quick-response.component';
import { VsmCommentsComponent } from './vsm-comments/vsm-comments.component';
import { EditVsmCommentsComponent } from './edit-vsm-comments/edit-vsm-comments.component';
import { AddContentCodeComponent } from './add-content-code/add-content-code.component';
import { PreviewMasterContentComponent } from './preview-master-content/preview-master-content.component';
import { EditMasterContentComponent } from './edit-master-content/edit-master-content.component';

const routes: Routes = [
  {
    path: '',
    component: AuthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: ContentListingComponent,
      },
      {
        path: 'content_group',
        canActivate: [AuthGuard],
        component: ContentGroupListingComponent,
      },
      {
        path: ':id/content',
        canActivate: [AuthGuard],
        component: ContentInfoComponent,
      },
      {
        path: ':id/preview',
        canActivate: [AuthGuard],
        component: ContentPreviewComponent,
      },
      {
        path: 'content_group/:id/edit',
        canActivate: [AuthGuard],
        component: EditGroupNameComponent,
      },
      {
        path: ':id/edit',
        canActivate: [AuthGuard],
        component: EditContentComponent,
      },
      {
        path: 'user_replies',
        canActivate: [AuthGuard],
        component: UserReplayListingComponent,
      },
      {
        path: 'user_replies/:type/edit',
        canActivate: [AuthGuard],
        component: EditUserReplayComponent,
      },
      {
        path: 'quick_responses',
        canActivate: [AuthGuard],
        component: QuickResponseListComponent,
      },
      {
        path: 'quick_responses/:id/edit',
        canActivate: [AuthGuard],
        component: EditQuickResponseComponent,
        data: {
          state: 'edit',
        },
      },
      {
        path: 'quick_responses/new',
        canActivate: [AuthGuard],
        component: EditQuickResponseComponent,
        data: {
          state: 'create',
        },
      },
      {
        path: 'vsm_comments',
        canActivate: [AuthGuard],
        component: VsmCommentsComponent,
      },
      {
        path: 'vsm_comments/:id/edit',
        canActivate: [AuthGuard],
        component: EditVsmCommentsComponent,
        data: {
          state: 'edit',
        },
      },
      {
        path: 'vsm_comments/new',
        canActivate: [AuthGuard],
        component: EditVsmCommentsComponent,
        data: {
          state: 'create',
        },
      },
      {
        path: 'create_master_code',
        canActivate: [AuthGuard],
        component: AddContentCodeComponent,
      },
      {
        path: 'preview-master-content/:id',
        canActivate: [AuthGuard],
        component: PreviewMasterContentComponent,
      },
      {
        path: 'edit-master-content/:templateId/:groupId',
        canActivate: [AuthGuard],
        component: EditMasterContentComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentsRoutingModule {}
